import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './MediaModalButtonGroup.scss';

const MediaModalButtonGroup = ({
	goToSlide,
	activeSlideIndex,
	onSlideChange,
	showShopNextPrevButtonToggleOn = true,
	loadMore = false,
	...rest
}) => {

	const {
		carouselState: { currentSlide, totalItems }
	} = rest;
	const totalDisplayedItems = currentSlide + 1;
	const remainingSlides = totalItems - totalDisplayedItems;
	const prevButtonDisabled = currentSlide === 0;
	const previousButtonClass = classNames('MediaModalButtonGroup__arrow', 'lpIcon-scrollleft');
	const nextButtonDisabled = !remainingSlides && !loadMore;
	const nextButtonClass = classNames('MediaModalButtonGroup__arrow', 'lpIcon-scrollright');

	useEffect(() => {

		goToSlide(activeSlideIndex, { skipBeforeChange: true });

	}, []);

	function prevArrowHandler () {

		if (currentSlide) {

			goToSlide(currentSlide - 1);
			onSlideChange(currentSlide - 1);

		}

	}
	function nextArrowHandler () {

		if (remainingSlides) {

			goToSlide(currentSlide + 1);
			onSlideChange(currentSlide + 1);

		}

	}

	if (!showShopNextPrevButtonToggleOn) {

		return null;

	}

	return (
		<div className="MediaModalButtonGroup">
			<button
				type="button"
				className={previousButtonClass}
				onClick={prevArrowHandler}
				disabled={prevButtonDisabled}
				aria-label="Previous"
			/>
			<button
				type="button"
				className={nextButtonClass}
				onClick={nextArrowHandler}
				disabled={nextButtonDisabled}
				aria-label="Next"
			/>
		</div>
	);

};

MediaModalButtonGroup.propTypes = {
	goToSlide: PropTypes.func,
	activeSlideIndex: PropTypes.number.isRequired,
	onSlideChange: PropTypes.func.isRequired,
	showShopNextPrevButtonToggleOn: PropTypes.bool,
	loadMore: PropTypes.bool
};

export default MediaModalButtonGroup;
